import React, { useState } from "react";
import styles from "./Sidebar.module.css";
import { menus } from "./menus";
import FooterComponent from "./FooterComponent";
import { NavLink } from "react-router-dom";
import BrandLogo from "../../assets/img/hgrlogo.png";
import arrowDown from "../../assets/img/arrow_down.svg";
import arrowUp from "../../assets/img/arrow_Up.svg";
import { Accordion, Card, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import * as action from "../../Store/Actions/index";
import "bootstrap/dist/css/bootstrap.css";

export default function SidebarComponent() {
  const [activeAccordian, setActiveAccordian] = useState(-1);
  const [active, setActive] = useState(true);
  const dispatch = useDispatch();
  const logout = () => {
    dispatch(action.logout());
    window.localStorage.clear();
    window.location.href = "/login";
  };
  const activateTab = (e, i) => {
    console.log(activeAccordian, i);
    if (activeAccordian == i) {
      setActiveAccordian(-1);
    } else {
      setActiveAccordian(i);
    }
  };
  function changeDownArrow() {
    setActive(false);
    setActive(!active);
  }
  function changeUpArrow() {
    setActive(true);
  }
  function buildSubLevelMenu(childMenus) {
    if (Array.isArray(childMenus) && childMenus.length > 0) {
      const subMenus = childMenus.map((menu) => {
        return (
          <NavLink
            to={menu.route}
            className={`list-group-item ${styles.list_group_sub_item}`}
            key={menu.title}
            activeClassName={styles.menu_active}
          >
            {menu.title}
          </NavLink>
        );
      });
      return (
        <ul
          className={` ${styles.list_group_flush} list-group list-group-flush `}
        >
          {subMenus}
        </ul>
      );
    }
    return null;
  }

  const menuItems = menus.map((menu) => {
    let permissions = JSON.parse(localStorage.getItem("permissions")) || [];
    if (localStorage.getItem("role") === "super_admin") {
      permissions = ["Super Admin"];
    }
    permissions.push("null");
    const hasSubMenu = Array.isArray(menu.child);

    const slidestyle = {
      padding: "0",
      backgroundColor: "#fff",
      borderBottom: "none",
    };
    const SlideStyleCard = {
      width: "auto",
      border: "none",
    };
    const slidestylebtn = {
      padding: "0",
      width: "100%",
      textAlign: "inherit",
    };
    const slidesubmenu = {
      padding: "10px",
    };

    return hasSubMenu ? (
      permissions.length > 1 ? (
        permissions.map((subMenu, indx) => {
          if (subMenu === menu.id) {
            return (
              <div id="accordion">
                <Accordion>
                  <Card className="acc_card" style={SlideStyleCard}>
                    <Card.Header
                      className={styles.acc_card_header}
                      onClick={(e) => activateTab(e, indx)}
                      style={slidestyle}
                    >
                      <Accordion.Toggle
                        as={Button}
                        variant="link"
                        eventKey={indx}
                        style={slidestylebtn}
                      >
                        <li
                          className={`list-group-item list-group-item ${styles.list_group_item}`}
                          key={indx}
                        >
                          <img
                            src={menu.img}
                            alt={menu.imgAlt}
                            className={`${styles.sb_image}`}
                          />
                          <img
                            src={menu.imgActive}
                            alt={menu.imgAlt}
                            className={`${styles.sb_image_active}`}
                          />
                          {menu.title}
                          {activeAccordian == indx ? (
                            <img
                              src={arrowUp}
                              alt="arrow"
                              className={`${styles.sb_arrow}`}
                            />
                          ) : (
                            <img
                              src={arrowDown}
                              alt="arrow"
                              className={`${styles.sb_arrow}`}
                            />
                          )}
                        </li>
                      </Accordion.Toggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey={indx} className="">
                      <Card.Body className="" style={slidesubmenu}>
                        {buildSubLevelMenu(menu.child)}
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
            );
          }
        })
      ) : (
        <>
          <NavLink
            to={`/quotes`}
            activeClassName={styles.menu_active}
            className={`list-group-item list-group-item ${styles.list_group_item} ${styles.anchor}`}
          >
            <li
              style={{ listStyle: "none" }}
              //  className={`list-group-item list-group-item  ${styles.list_group_item}`}
              key={menu.title}
              onClick={(e) => activateTab(e)}
            >
              <img
                src={menu.img}
                alt={menu.imgAlt}
                className={`${styles.sb_image}`}
              />
              <img
                src={menu.imgActive}
                alt={menu.imgAlt}
                className={`${styles.sb_image_active}`}
              />
              <span>{menu.title}</span>

              {active === true ? (
                <img
                  src={arrowDown}
                  alt="arrow"
                  className={`${styles.sb_arrow}`}
                  onClick={() => changeDownArrow()}
                />
              ) : (
                <img
                  src={arrowUp}
                  alt="arrow"
                  className={`${styles.sb_arrow}`}
                  onClick={() => changeUpArrow()}
                />
              )}
            </li>
          </NavLink>
          {active === false && <>{buildSubLevelMenu(menu.child)}</>}
        </>
      )
    ) : permissions.length > 1 ? (
      permissions.map((subMenu) => {
        if (subMenu === menu.id) {
          return (
            <NavLink
              // exact
              to={menu.route}
              className={`list-group-item list-group-item ${styles.list_group_item}`}
              key={menu.title}
              activeClassName={styles.menu_active}
            >
              <img
                src={menu.img}
                alt={menu.imgAlt}
                className={`${styles.sb_image}`}
              />
              <img
                src={menu.imgActive}
                alt={menu.imgAlt}
                className={`${styles.sb_image_active}`}
              />
              {menu.title}
            </NavLink>
          );
        }
      })
    ) : (
      <NavLink
        // exact
        to={menu.route}
        className={`list-group-item list-group-item ${styles.list_group_item}`}
        key={menu.title}
        activeClassName={styles.menu_active}
      >
        <img
          src={menu.img}
          alt={menu.imgAlt}
          className={`${styles.sb_image}`}
        />
        <img
          src={menu.imgActive}
          alt={menu.imgAlt}
          className={`${styles.sb_image_active}`}
        />
        {menu.title}
      </NavLink>
    );
  });

  return (
    <>
      <div className="showIn_mobile">
        <nav className="navbar navbar-expand-xs">
          <a className="navbar-brand" href="/dashboard">
            <div className={` ${styles.logo_brand}`}>
              <img src={BrandLogo} alt="logo" />
            </div>
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#collapsibleNavbar"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="collapsibleNavbar">
            <ul className="navbar-nav">
              <li className="nav-item">
                <a className="nav-link" href="/dashboard">
                  Dashboard
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/customer">
                  Customer
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/ship">
                  Shipment
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/quotes">
                  Quotes
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/abandoned">
                  Abandoned
                </a>
              </li>
              
              <li className="nav-item">
                <a className="nav-link" href="/settings">
                  Settings
                </a>
              </li>
              {/* <li className="nav-item">
                <a className="nav-link" href="" onClick={() => logout()}>
                  Logout
                </a>
              </li> */}
            </ul>
          </div>
        </nav>
      </div>

      <div
        className={`col-lg-2 col-md-3 col-sm-0 px-0 ${styles.management_sidebar}`}
      >
        <Accordion>
          <div className={` ${styles.logo}`}>
            <img src={BrandLogo} alt="logo" />
          </div>
          <ul className={`list-group list-group-flush ${styles.list_group}`}>
            {menuItems}
          </ul>

          <FooterComponent />
        </Accordion>
      </div>
    </>
  );
}
